import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "uikit";

import useGpsSpoofing, {
	GPS_SPOOFING_TRANSLATION_PATH,
} from "../../../../../../../../../../hooks/useGpsSpoofing";
import { Divider } from "../../../../../../../../../../components";
import { AccessGuard } from "../../../../../../../../../../components/common";
import { TabAccessNames, TabKeys } from "../../constants/access";
import Button from "../Button";

/** Drivers' GPS spoofing toggle, granted by a role permission. */
const GpsSpoofingButton: React.FC = () => {
	const { t } = useTranslation();
	const { active, hintKey, disabled, toggle } = useGpsSpoofing();
	const hint = t(`${GPS_SPOOFING_TRANSLATION_PATH}.${hintKey}`) ?? "";

	return (
		<AccessGuard accessName={TabAccessNames[TabKeys.GPS_SPOOFING]}>
			{/* a disabled button gets no hover, so the hint sits on the wrapper */}
			<span title={disabled ? hint : undefined}>
				<Button
					title={disabled ? undefined : hint}
					active={active}
					tabIndex={-1}
					onClick={toggle}
					disabled={disabled}
					style={disabled ? { pointerEvents: "none" } : undefined}
				>
					<Icon id="orders-gps-spoofing" size={20} />
				</Button>
			</span>
			<Divider
				orientation="vertical"
				size={16}
				color="rgba(0, 0, 0, 0.12);"
			/>
		</AccessGuard>
	);
};

export default GpsSpoofingButton;
